module.exports = __webpack_public_path__ + "static/videoplayback-031ae9720f0ccb916f7104c16d579b59.mp4";